module.exports = __webpack_public_path__ + "img/close.ef6f77bc.svg";